// Persists the in-progress order (location + form selections) across the
// full-page redirect to Stripe's hosted checkout and back — a real browser
// navigation remounts the whole app, so any React state would otherwise be
// lost entirely, forcing the customer to re-search and re-fill the form
// from scratch if they cancel and come back.

export interface PendingOrder {
  locationName: string;
  // The searched/landing place name — what the big label shows. Kept apart
  // from locationName (which follows pan/zoom reverse-geocoding).
  labelName: string;
  address: string;
  coords: [number, number];
  zoom: number;
  sizeLabel: string | null;
  country: 'Australia' | 'New Zealand' | null;
  mapStyle: 'default' | 'suburbs';
}

const STORAGE_KEY = '25maps_pending_order';

export function savePendingOrder(order: PendingOrder): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(order));
  } catch {
    // sessionStorage can fail in some contexts (private browsing, storage
    // disabled) — not worth blocking checkout over, just skip persistence.
  }
}

export function takePendingOrder(): PendingOrder | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(STORAGE_KEY); // one-time use
    return JSON.parse(raw) as PendingOrder;
  } catch {
    return null;
  }
}

export function clearPendingOrder(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
